import { render, staticRenderFns } from "./EmployeeLeaveAttendanceWrapper.vue?vue&type=template&id=0ff57b3b&scoped=true"
import script from "./EmployeeLeaveAttendanceWrapper.vue?vue&type=script&lang=js"
export * from "./EmployeeLeaveAttendanceWrapper.vue?vue&type=script&lang=js"
import style0 from "./EmployeeLeaveAttendanceWrapper.vue?vue&type=style&index=0&id=0ff57b3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff57b3b",
  null
  
)

export default component.exports